import TimerIcon from '@mui/icons-material/Timer'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import { Box } from '@mui/material'
import { useRecordContext } from 'react-admin'

import { HeaderSection } from './AdvancedInfoWindow'
import FieldRow from './FieldRow'
import CircularGaugeIcon from '../CircularGaugeIcon'
import SpeedField from './SpeedField'
import UnitField from '../UnitField'
import { SpeedLimitBadge } from './TelemacticContextSection'

const getDurationThresholds = (maxSpeed) => {
  if (maxSpeed <= 30)
    return [
      { limit: 5, color: '#ffb74d', label: 'speeding.momentary' },
      { limit: 15, color: '#ed6c02', label: 'speeding.prolonged' },
      { limit: Infinity, color: '#d32f2f', label: 'speeding.sustained' },
    ]

  if (maxSpeed <= 70)
    return [
      { limit: 10, color: '#ffb74d', label: 'speeding.momentary' },
      { limit: 30, color: '#ed6c02', label: 'speeding.prolonged' },
      { limit: Infinity, color: '#d32f2f', label: 'speeding.sustained' },
    ]

  return [
    { limit: 20, color: '#ffb74d', label: 'speeding.momentary' },
    { limit: 60, color: '#ed6c02', label: 'speeding.prolonged' },
    { limit: Infinity, color: '#d32f2f', label: 'speeding.sustained' },
  ]
}
const SpeedingSection = ({ event_data }) => {
  const { max_speed } = useRecordContext()
  const { duration } = event_data
  return (
    <>
      <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyItems: 'center', gap: 1, mb: 1 }}>
        <SpeedLimitBadge value={max_speed} />
        <HeaderSection
          title="speeding" // TODO: make text dynamic based on severity
          sx={{ fontWeight: 700, color: '#444', letterSpacing: 0.3 }}
        />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: 1.5,
          rowGap: 0.25,
          alignItems: 'center',
          justifyItems: 'start',
        }}
      >
        <SpeedField source="speed" max_speed={max_speed} helperText="resources.vehicles.infoWindow.speeding.speed" />
        <SpeedField
          source="max_speed_recorded"
          max_speed={max_speed}
          icon={TrendingUpIcon}
          record={event_data}
          helperText="resources.vehicles.infoWindow.speeding.peak"
        />

        <FieldRow
          icon={<CircularGaugeIcon Icon={TimerIcon} thresholds={getDurationThresholds(max_speed)} value={duration} />}
          helperText="resources.vehicles.infoWindow.speeding.duration"
        >
          <UnitField record={event_data} source="duration" unit="s" />
        </FieldRow>
      </Box>
    </>
  )
}

export default SpeedingSection
